import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  DialogActions,
  Table,
  TableBody,
  TableHead,
  TableCell,
} from '@mui/material'
import { HighlightOff as HighlightOffIcon } from '@mui/icons-material'

import { useEffect, useState } from 'react'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { additionalNotesService } from '../../../services/additionalNotesService'
import { fileServices } from '../../../services/fileServices'
import PreviewRowWrapper from './PreviewRowWrapper'
import EditingRowWraper from './EditingRowWraper'
import { useProcessContext } from '../../../store'
import moment from 'moment'

const AdditionalNotes = ({
  processId,
  isAdditionalNoteDialogue,
  setIsAdditionalNoteDialogue,
  processReferenceNum,
  processTemplateId,
}) => {
  const { user } = useAuthContext()
  const [data, setData] = useState([])
  const processContext = useProcessContext((state) => state.processContext)

  const getNotes = async () => {
    const fetchedAdditionalNotesData = await additionalNotesService.getAdditonalNotes(
      user,
      processReferenceNum,
      processTemplateId
    )
    setData(fetchedAdditionalNotesData.notesData.map((it) => ({ ...it, editing: false })))
  }

  useEffect(() => {
    ;(async () => {
      await getNotes()
    })()
  }, [user, processReferenceNum, processTemplateId])

  async function deleteNotes(noteId) {
    await additionalNotesService.deleteNotes(user, noteId)
    let updatedNotes = data.filter((it) => it.id != noteId)
    setData(updatedNotes)
  }

  const addRow = () => {
    setData([
      ...data,
      {
        temp_id: new Date().getTime(),
        data_structure: 'text',
        description: '',
        content: '',
        editing: true,
        user_id: user.id,
        activity_template_name: processContext?.activityTemplate?.activity_template_name,
        version: processContext?.processData?.version,
      },
    ])
  }

  return (
    <Dialog open={isAdditionalNoteDialogue} fullWidth maxWidth="md">
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography className="textPrimary fontWeight700 fontsize16" variant="h5">
            Additional Notes
          </Typography>
          <IconButton
            align="right"
            onClick={() => {
              setIsAdditionalNoteDialogue(false)
            }}
            size="small"
          >
            <HighlightOffIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent className="pb-0">
        <Table>
          <TableHead>
            <TableCell width={50}>Type</TableCell>
            <TableCell width={200}>Brief Description</TableCell>
            <TableCell width={450}>Content</TableCell>
            <TableCell width={150}>Activity</TableCell>
            <TableCell>Added by</TableCell>
            <TableCell width={100}>Added on</TableCell>
            <TableCell>Actions</TableCell>
          </TableHead>
          <TableBody>
            {data
              ?.sort((a, b) => moment(a.modified_at) - moment(b.modified_at))
              ?.map((d) => {
                return d.editing ? (
                  <EditingRowWraper
                    note={d}
                    processId={processId}
                    activityTemplateName={processContext?.activityTemplate?.activity_template_name}
                    version={processContext?.processData?.version}
                    setPreview={(updatedNote) => {
                      setData(
                        data.map((it) =>
                          it.id == updatedNote.id ? { ...updatedNote, editing: false } : it
                        )
                      )
                    }}
                    addNewRow={(updatedNote) => {
                      setData(
                        data.map((it) =>
                          it.temp_id == updatedNote.temp_id
                            ? { ...updatedNote, editing: false }
                            : it
                        )
                      )
                    }}
                  />
                ) : (
                  <PreviewRowWrapper
                    note={d}
                    deleteNotes={deleteNotes}
                    processId={processId}
                    fileServices={fileServices}
                    setEditable={(id) => {
                      setData(data.map((it) => (it.id == id ? { ...it, editing: true } : it)))
                    }}
                  />
                )
              })}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'flex-end' }}>
        <div style={{ display: 'flex', columnGap: 16, marginBottom: 0, padding: '8px 20px' }}>
          <Button color="primary" variant="contained" sx={{ height: 26 }} onClick={addRow}>
            Add Row
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default AdditionalNotes
